
import { useState, useEffect } from 'react';
import { Navigation } from './Navigation';

const heroImages = [
  {
    url: 'https://public.readdy.ai/ai/img_res/b2ee3363a00dd4115a2b19264223b8e7.jpg',
    alt: '奄美大島の美しいビーチと青い海'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Breathtaking%20sunset%20over%20Amami%20Oshima%20coastline%2C%20golden%20orange%20sky%20reflecting%20on%20calm%20turquoise%20ocean%20surface%2C%20silhouette%20of%20tropical%20palm%20trees%20and%20coastal%20vegetation%2C%20dramatic%20clouds%20with%20warm%20pink%20and%20purple%20hues%2C%20peaceful%20serene%20atmosphere%2C%20professional%20landscape%20photography%2C%20rich%20warm%20colors%2C%20cinematic%20composition&width=1920&height=1080&seq=amami-hero-2&orientation=landscape',
    alt: '奄美大島の夕暮れの風景'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Pristine%20mangrove%20forest%20in%20Amami%20Oshima%20with%20emerald%20green%20water%20channels%2C%20dense%20tropical%20vegetation%20with%20unique%20mangrove%20trees%2C%20clear%20shallow%20water%20reflecting%20blue%20sky%2C%20natural%20ecological%20paradise%2C%20vibrant%20green%20foliage%2C%20peaceful%20natural%20environment%2C%20professional%20nature%20photography%2C%20bright%20natural%20lighting%2C%20high%20clarity&width=1920&height=1080&seq=amami-hero-3&orientation=landscape',
    alt: '奄美大島のマングローブ林'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Magnificent%20coral%20reef%20underwater%20scene%20near%20Amami%20Oshima%2C%20colorful%20tropical%20fish%20swimming%20in%20crystal%20clear%20turquoise%20water%2C%20vibrant%20coral%20formations%2C%20sunlight%20rays%20penetrating%20water%20surface%2C%20pristine%20marine%20ecosystem%2C%20bright%20vivid%20colors%2C%20professional%20underwater%20photography%20style%2C%20excellent%20visibility%2C%20natural%20beauty&width=1920&height=1080&seq=amami-hero-4&orientation=landscape',
    alt: '奄美大島の海中風景'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Amami%20Oshima%20tropical%20rainforest%20mountains%20covered%20with%20lush%20green%20vegetation%2C%20misty%20morning%20atmosphere%20with%20soft%20clouds%2C%20winding%20coastal%20road%20visible%2C%20turquoise%20ocean%20in%20background%2C%20pristine%20natural%20landscape%2C%20fresh%20green%20colors%2C%20professional%20landscape%20photography%2C%20serene%20peaceful%20mood%2C%20high%20definition&width=1920&height=1080&seq=amami-hero-5&orientation=landscape',
    alt: '奄美大島の山々と自然'
  }
];

export function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {heroImages.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="w-full h-full">
            <img
              src={image.url}
              alt={image.alt}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/35"></div>
        </div>
      ))}

      <Navigation isScrolled={isScrolled} />

      <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6">
        <div className="w-full max-w-4xl text-center">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-white mb-4 sm:mb-6 tracking-tight leading-tight" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            奄美の医療を支える
          </h1>
          <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light text-teal-400 mb-3 sm:mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            鹿児島県奄美薬剤師会
          </p>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/80 mb-8 sm:mb-12 font-light px-4">
            薬剤師、医療従事者、そして<br className="sm:hidden" />未来の医療を担う学生の皆様へ
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center px-4">
            <button
              onClick={() => scrollToSection('about')}
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white text-gray-900 rounded-xl font-medium text-base sm:text-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              協会について
            </button>
            <button
              onClick={() => scrollToSection('calendar')}
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-transparent border-2 border-white text-white rounded-xl font-medium text-base sm:text-lg hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              研修カレンダー
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 z-10 flex gap-2 sm:gap-3">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentImageIndex
                ? 'bg-amber-500 w-6 sm:w-8'
                : 'bg-white/30 hover:bg-white/50'
            }`}
            aria-label={`画像 ${index + 1} を表示`}
          ></button>
        ))}
      </div>
    </section>
  );
}
